<template>
  <!-- <v-snackbar
    v-model="notificationComponent"
    :bottom="y === 'bottom'"
    :left="x === 'left'"
    :multi-line="mode === 'multi-line'"
    :right="x === 'right'"
    :timeout="timeout"
    :top="y === 'top'"
    :vertical="mode === 'vertical'"
    :class="{
        'cmp-notificationComponent': true,
        'dt-error': type == 'error'
      }"
  >
    {{ text }}
  </v-snackbar> -->
  <transition name="slide-fade">
    <div
      class="cmp-notificationComponent"
      :class="{
        'error-notification': type == 'error',
      }"
      v-if="notificationComponent"
    >
      <div class="notification-row">
        <div class="dt-icon-container notification-icon">
          <img
            :src="
              type == 'error'
                ? `static/icons/exclamation-dark.svg`
                : `static/icons/exclamation.svg`
            "
            class="dt-icon v5 s1"
            alt="Info"
            title="Info"
          />
        </div>
        <div class="notification-text">
          {{ text }}
        </div>
        <div class="notification-divider"></div>
        <div class="notification-button">
          <IconButton
            @click="close"
            :size="6.7"
            :icon="type == 'error' ? `delete-dark-compact` : `delete-compact`"
          />
          <!-- <div class="dt-icon-container">
            <img
              @click="close"
              :src="
                type == 'error'
                  ? `static/icons/delete-dark.svg`
                  : `static/icons/delete-compact-2.svg`
              "
              class="dt-icon v5 s16p"
              alt="Delete Invoice Line"
              title="Delete Invoice Line"
            />
          </div> -->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// import IconButton from "../plugins/button/button.js";
import { IconButton } from "../../plugins/button/button";

import {
  DEFAULT_OPTIONS,
  NotificationService,
} from "./notification.service.js";

export default {
  components: {
    IconButton,
  },
  data: function () {
    return {
      notificationComponent: false,
      id: null,

      y: "top",
      x: "right",
      mode: "error",
      type: "normal",
      timeout: 6000,
      text: "Hello, I'm a notificationComponent",
    };
  },
  methods: {
    show: function (options = DEFAULT_OPTIONS) {
      if (this.notificationComponent) {
        // this.close();
        // this.$nextTick(() => this.show(options));
        // return;
      }
      Object.keys(options).map((key) => {
        this[key] = options[key];
      });
      this.notificationComponent = true;
    },
    close: function () {
      this.notificationComponent = false;
      this.$nextTick(() => {
        NotificationService.closeNotification(this.id);
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-notificationComponent {
  /* position: fixed; */
  top: 8px;
  right: 24px;
  z-index: 99;
  background: #282828;
  color: white;
  height: 40px;
  width: max-content;
  border-radius: 6px;

  margin: 4px 0px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: Roboto, sans-serif;

  transition: all 150ms ease-out;

  --divider-color: var(--text-5);

  &.error-notification {
    background: #ff6e6e !important;
    color: #282828;
  }

  .notification-row {
    display: flex;
    align-items: center;

    .notification-icon {
      padding: 0px 8px;
    }
    .notification-text {
      padding: 0px 8px 0px 0px;
    }
    .notification-divider {
      width: 1px;
      background: var(--divider-color);
      height: 16px;
      margin-right: 3px;
    }
    .notification-button {
      padding-right: 6px;
    }
  }

  &.dt-error {
    font-family: "roboto";
    .snack__wrapper {
      background: #ad0000;
    }
  }
}

/* .snack-transition {
  &-enter-active,
  &-leave-active {
    transition: transform 200ms cubic-bezier(0.25, 0.8, 0.5, 1);
    .snack__content {
      transition: opacity 100ms linear 0.1s;
    }
  }
} */

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(100px);
  opacity: 0.25;
}
</style>
